<template>
<div>
    <div class="home">
        <div class="item-page page-1">
            <HomeHeaderNav :curTab="1"/>
            <div class="main">
                <div class="left-contain">
                    <div>
                        <h3>让你看，帮你选，打造下一个经典爆款</h3>
                        <p>这里有专业的剧本审读团队，帮你筛选贴近市场的潜力作品；这里有钻营市场多年的阅片大神，帮你变现潜质IP；</p>
                        <p>这里有深耕豆瓣，深谙观众心理的影迷，帮你把关剧本交易。</p>
                        <a href="/buy.html" target="_blank"><button class="skip-btn">买剧本</button></a>
                    </div>
                    <div class="line"></div>
                    <div>
                        <h3>助力剧本成交，保障编剧权益</h3>
                        <p>这是个有梦的团队，这里有最会读故事的人，这里有最了解市场的人。如果你有原创剧本，我们会帮你推介，促成剧本交易；</p>
                        <p>如果你想写剧本，我们有国内顶尖编剧的课程，助你成为真正的编剧；如果你想剧本进阶，这里有强有力的剧本评估系统，助你破解观众心理。</p>
                        <a href="/sell.html" target="_blank"><button class="skip-btn">卖剧本</button></a>
                    </div>
                </div>
                <div class="right-contain">
                    <div class="search-wrap">
                        <div class="search-box">
                            <input type="text"  @keyup.enter="searchScript" @focus="searchInputOnFocus" v-model="searchKeyWord" placeholder="请输入剧本名称" maxlength="10">
                            <button class="search-btn" @click="searchScript"></button>
                            <ul class="result-list" v-if="showSearchResult">
                                <a :href="'/scriptdetail.html?id='+item.id" v-for="(item,index) in searchResult" :key="index" target="_blank">
                                    <img src="../../assets/2021/search-result.png" alt=""><li>{{item.title}}</li>
                                </a>
                            </ul>
                        </div>
                    </div>
                    <ul class="rec-wrap">
                        <a :href="'/scriptdetail.html?id='+item.id" v-for="(item,index) in topRecommend" :key="index" target="_blank">
                            <li class="rec-item">
                                <img :src="item.image" alt="">
                                <div class="info">
                                    <p class="title">{{item.title}}</p>
                                    <div class="tag">{{item.two_cateid_name.slice(0,2).join('&nbsp&nbsp|&nbsp&nbsp')}}</div>
                                    <div class="line"></div>
                                    <div class="intro">{{item.yijuhua}}</div>
                                </div>
                            </li>
                        </a>
                    </ul>
                </div>
            </div>
            <div class="to-next-btn">
            </div> 
        </div>
        <div class="item-page page-2">
            <div class="serve-intro">
                <div class="serve-item serve-intro-left">
                    <div class="icon-box"><img src="../../assets/2021/serve1.png" alt=""></div>
                    <p class="title">剧本经纪</p>
                    <p class="intro">北门中文网提供专业的影视版权交易，包括商务策划、剧本备案、剧本推介等服务。</p>
                </div>
                <div class="serve-item serve-intro-center">
                    <div class="icon-box"><img src="../../assets/2021/serve2.png" alt=""></div>
                    <p class="title">编剧经纪</p>
                    <p class="intro">依托知名编剧，制作公司等资源，北门中文网将为合作编剧提供影视项目合作机会。</p>
                </div>
                <div class="serve-item serve-intro-right">
                    <div class="icon-box"><img src="../../assets/2021/serve3.png" alt=""></div>
                    <p class="title">剧本评估</p>
                    <p class="intro">我们为在本站上传的剧本提供剧本评估服务，以专业的剧本修改建议，助力剧本成交。</p>
                </div>
            </div>
            <div class="success-cases">
                <div class="left-item">
                    <img src="../../assets/2021/suc1.png" alt="">
                    <p class="info">
                        <span class="title">战火熔炉</span>
                        <span class="intro">纪念中国人民志愿军抗美援朝出国作战70周年</span>
                    </p>
                </div>
                <div class="center-item">
                    <img src="../../assets/2021/suc2.png" alt="">
                    <img src="../../assets/2021/suc3.png" alt="">
                </div>
                <div class="right-item">
                    <img src="../../assets/2021/suc4.png" alt="">
                </div>
            </div>
            <div class="partners-wrap">
                <div class="title">
                    <img src="../../assets/2021/partners.png" alt="">
                </div>
                <div class="item">
                    <img src="../../assets/img/p1.png" alt="">
                    <img src="../../assets/img/p2.png" alt="">
                    <img src="../../assets/img/p3.png" alt="">
                    <img src="../../assets/img/p4.png" alt="">
                    <img src="../../assets/img/p5.png" alt="">
                    <img src="../../assets/img/p6.png" alt="">
                </div>
            </div>
            <!-- <div class="footer">
                <div class="footer-content">
                    <div class="copyright">
                        <span>备案号京字第06868号</span><span>版权所有：北京北门逐鹿影视传媒有限公司2020</span>
                    </div>
                    <div class="contact-box">
                        <div @mouseenter="wxCodeShow = true" @mouseleave="wxCodeShow = false">
                            <img src="../../assets/2021/wechat.png" alt="">
                            <img src="../../assets/2021/wx-code.png" alt="" class="code-img" v-show="wxCodeShow">
                        </div> 
                        <div @mouseenter="xcxCodeShow = true" @mouseleave="xcxCodeShow = false">
                            <img src="../../assets/2021/feedback.png" alt="">
                            <img src="../../assets/2021/xcx-code.png" alt="" class="code-img" v-show="xcxCodeShow">
                        </div>
                    </div>
                </div>
            </div> -->
            
            <div class="back-to-top-wrap" title="返回顶部" @click="toScrollTop" v-if="isPageScroll">
            </div>
        </div>
    </div>
    <Footer/>
    </div>
</template>

<script>
import HomeHeaderNav from '@/components/HomeHeaderNav'
import Footer from '@/components/Footer'
import Axios from '@/api/Axios'
export default {
    name:'Home',
    data(){
        return{
            toNextPage:false,           //滚动鼠标或者按下方向键或点击翻页按钮式滚动到下一个页面
            toPrevPage:false,           //滚动鼠标或者按下方向键或点击翻页按钮式滚动到下一个页面
            topRecommend:'',            //储存首页顶部推荐位数据
            searchKeyWord:'',           //搜索关键词
            searchResult:'',            //搜索结果
            showSearchResult:false,     //根据是否有所搜结果控制模糊搜索列表显示隐藏
            timeout:null,
            isPageScroll:false,         //判断页面是否往下滚动若滚动显示返回顶部按钮
            fontSize:'',
            wxCodeShow:false,
            xcxCodeShow:false
        }
    },
    created(){
        this.setRootFontSize()
        //获取首页模块数据
        Axios.get('index/module').then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
                    this.topRecommend=response.data.data.tuijian
                }
            },
            error=>{
                
                console.log(error)
                this.$message.error({
                    message: '出错了 请刷新重试',
                    type: 'error',
                    center:true,
                    offset:100,
                    duration:900
                })
            }
        )
    },
    watch:{
        searchKeyWord(curVal,oldVal){
            clearTimeout(this.timeout)
            this.timeout=setTimeout(()=>{
                this.getSearchResult(curVal)
            },300)
        }
    },
    mounted(){
        window.addEventListener('click', (e)=> {
            if(e.target.type!=="text"){
                this.showSearchResult=false
            }
        }, false)
        //window.addEventListener('mousewheel',this.debounce(this.handleScroll,300),true||window.addEventListener("DOMMouseScroll",this.debounce(this.handleScroll,300),false))
        window.addEventListener('resize', ()=> {
            this.setRootFontSize()
        }, false);
    },
    methods:{
        //页面响应式自适应
        setRootFontSize() {
            let width = document.documentElement.offsetWidth || document.body.offsetWidth;
            this.fontSize = (width*100/1920)
            document.getElementsByTagName('html')[0].style['font-size'] = this.fontSize + 'px';
        },
        //返回顶部 
        toScrollTop(){
            let top=document.documentElement.scrollTop || document.body.scrollTop
            const timeTop=setInterval(()=>{
                document.body.scrollTop = document.documentElement.scrollTop = top -= 50
                if (top <= 0) {
                    clearInterval(timeTop)
                }
            },10)
        },
        //鼠标滚动切换时防抖函数
        // debounce(func,wait){
        //     let timeout;
        //     return function(){
        //         let context=this;
        //         let args=arguments;
        //         if(timeout) clearTimeout(timeout);
        //         timeout = setTimeout(()=>{
        //             func.apply(context,args)
        //         },wait)
        //     }
        // },
        //光标移入搜索框时根据是否有搜索内容判断是否进行搜索
        searchInputOnFocus(){
            if(this.searchKeyWord){
                this.showSearchResult=true
            }else{
                return false
            }
        },
        //搜索框输入
        getSearchResult(inputVal){
            if(inputVal===""){
                this.showSearchResult=false
                return false
            }
            this.searchResult=""
            if(this.searchKeyWord===inputVal){
                let date=new Date()
                this.now=date.getFullYear()+'-'
                this.now=this.now+(date.getMonth()+1)+'-'
                this.now=this.now+(date.getDate())+' '
                this.now=this.now+(date.getHours())+':'
                this.now=this.now+(date.getMinutes())+':'
                this.now=this.now+(date.getSeconds())
                this.showSearchResult=false
                Axios.get('/article/list',{'search':this.searchKeyWord,'limitdate':this.now}).then(
                    response=>{
                        if(response.data.code==200&&response.data.status=='success'){
                            if(response.data.data.length){
                                //如果搜索结果为唯一且完全匹配则收起模糊搜索结构显示框
                                if(response.data.data.length==1&&response.data.data[0].title==this.searchKeyWord){
                                    this.showSearchResult=false
                                    this.searchResult=response.data.data
                                }else{
                                    this.searchResult=response.data.data
                                    this.showSearchResult=true
                                }
                            }else{
                                this.showSearchResult=false
                            }
                        }
                    },
                    error=>{
                        console.log(error)
                        this.$message.error({
                            message: '出错了  请稍后重试',
                            type: 'error',
                            center:true,
                            offset:100,
                            duration:900
                        })
                    }
                )
            }
        },
        //判断滚动方向
        // handleScroll(e){
        //     if(e.deltaY>0){
        //         let top=document.documentElement.scrollTop||document.body.scrollTop
        //         let viewH=document.body.clientHeight||document.documentElement.clientHeight
        //         const timeToNext=setInterval(()=>{
        //             document.body.scrollTop=document.documentElement.scrollTop=top += 20
        //             if(top>=viewH){
        //                 clearInterval(timeToNext)
        //             }
        //         },10)
        //     }else{
        //         let top=document.documentElement.scrollTop||document.body.scrollTop
        //         let viewH=document.body.clientHeight||document.documentElement.clientHeight
        //         const timeToPrev=setInterval(()=>{
        //             document.body.scrollTop=document.documentElement.scrollTop=top -= 20
        //             if(top<=0){
        //                 clearInterval(timeToPrev)
        //             }
        //         },10)
        //     }
        // },
        //点击箭头跳转到下一页
        // scrollToNext(){
        //     let top=document.documentElement.scrollTop||document.body.scrollTop
        //     let viewH=document.body.clientHeight||document.documentElement.clientHeight
        //     const timeToNext=setInterval(()=>{
        //         document.body.scrollTop=document.documentElement.scrollTop=top += 20
        //         if(top>=viewH){
        //             clearInterval(timeToNext)
        //         }
        //     },10)
        // },
        searchScript(){
            if(this.searchKeyWord==''){
                this.$message.error({
                    message: '请输入剧本名称',
                    type: 'error',
                    center:true,
                    offset:100,
                    duration:900
                })
            }else{
                if(this.searchResult.length){
                    window.open('/scriptdetail.html?id='+ this.searchResult[0].id)
                }else{
                    this.$message.warning({
                        message: '未搜到相关剧本',
                        type: 'warning',
                        center:true,
                        offset:100,
                        duration:900
                    })
                }
            }
        }
    },
    components:{
        HomeHeaderNav,
        Footer
    }
}
</script>

<style lang="scss">
html{
    font-size:100px;
}
body{
    // overflow-y:hidden !important;
    //overflow-x:hidden !important;
}
@keyframes bounce{
    from{
        opacity:0.5;
        bottom:86px;
    }
    to{
        opacity:1;
        bottom:76px;
    }
}
.home{    
    width:100%;
    //min-width:1696px;
    //height:200%;
    .item-page{
        height:50%;
    }
    .page-1{
        background:url('../../assets/2021/home-bg.png') no-repeat;
        background-size:100% 100%;
        overflow-y:hidden;
        height:100vh;
        .main{
            width:15.80rem;
            overflow:hidden;
            margin:0 auto;
            h3{
                font-size:0.42rem;
                color:#fff;
                margin:0;
                margin-bottom:0.3rem;
            }
            p{
                color:#fefefe;
                font-size:0.15rem;
                width:9rem;
                line-height:0.32rem;
            }
            .skip-btn{
                width: 1.81rem;
                height: 0.49rem;
                background: #B31E23;
                border-radius:24px;
                color:#fff;
                font-size:0.18rem;
                letter-spacing: 1px;
                outline:none;
                border:none;
                cursor:pointer;
                margin-top:0.40rem;
                vertical-align: top;
            }
            .left-contain{
                width:9.52rem;
                float:left;
                margin-right:1.10rem;
                margin-top:0.36rem;
                .line{
                    height:1px;
                    background:url('../../assets/2021/line.png') no-repeat;
                    background-size:100% 100%;
                    margin:0.8rem 0;
                }
            }
            .right-contain{
                float:left;
                width:3.74rem;
                .search-wrap{
                    margin-bottom:0.24rem;
                    height: 0.50rem;
                    line-height:0.50rem;
                }
                .search-box{
                    vertical-align:top;
                    position:relative;
                    height: 0.50rem;
                    input{
                        vertical-align:top;
                        width: 2.72rem;
                        height: 0.50rem;
                        background: #FFFFFF;
                        border-radius: 6px;
                        color:#222;
                        border:none;
                        outline:none;
                        margin-right:0.10rem;
                        font-size:0.16rem;
                        padding-top:0;
                        padding-bottom:0;
                        padding-left:0.14rem;
                    }
                    input::placeholder{
                        color: #B3B3B3;
                    }
                    .search-btn{
                        vertical-align:top;
                        width:0.74rem;
                        height:0.5rem;
                        background:url('../../assets/2021/search-btn.png') no-repeat;
                        background-size:100% 100%;
                        border:none;
                        outline:none;
                        cursor:pointer;
                    }
                    .result-list{
                        width:2.58rem;
                        position:absolute;
                        background:#fff;
                        left:0;
                        top:0.54rem;
                        padding:0.10rem 0.14rem;
                        border-radius:4px;
                        a{
                            width:100%;
                            display:inline-block;
                            text-decoration:none;
                            color:#999;
                            img{
                                width:0.20rem;
                                height:0.20rem;
                                vertical-align:middle;
                                margin-right:0.06rem;
                            }
                            li{
                                width:2.32rem;
                                padding:0.08rem 0;
                                vertical-align:middle;
                                display:inline-block;
                                border-bottom:1px solid #e6e6e6;
                                overflow:hidden;
                                font-size:0.14rem;
                            }
                            li:hover{
                                opacity:0.8;
                            }
                        }
                        a:last-child{
                            li{
                                border-bottom:none;
                            }
                        }
                    }
                }
                .rec-wrap{
                    .rec-item{
                        width:3.42rem;
                        height:0.98rem;
                        margin-bottom:0.16rem;
                        background:#373839;
                        border-radius:6px;
                        padding:0.16rem;
                        img{
                            width:0.7rem;
                            height:1rem;
                            float:left;
                            margin-right:0.20rem;
                        }
                        .info{
                            width:2.52rem;
                            float:left;
                            .title{
                                font-size:0.16rem;
                                color:#fff;
                                font-weight:bold;
                                margin-bottom:0.18rem;
                                height:0.2rem;
                                line-height:0.2rem;
                            }
                            .tag{
                                font-size:0.14rem;
                                color:#AFB0B0;
                            }
                            .line{
                                width:0.13rem;
                                height:0.01rem;
                                background:#616263;
                                margin:0.1rem 0;
                            }
                            .intro{
                                font-size:0.14rem;
                                color:#fff;
                                display:-webkit-box;
                                overflow:hidden;
                                text-overflow:ellipsis;
                                -webkit-line-clamp:1;
                                -webkit-box-orient:vertical;
                            }
                        }
                    }
                }
            }
        }
        .to-next-btn{
            position:absolute;
            width:0.26rem;
            height:0.26rem;
            background:url('../../assets/2021/to-next.png') no-repeat;
            background-size:100% 100%;
            bottom:0.86rem;
            left:50%;
            transform:translateX(-50%);
            animation-name: bounce;
            animation-duration:0.7s;
            animation-iteration-count:infinite;
            animation-direction: alternate;
        }
    }
    .page-2{
        background:#fff;
        .serve-intro{
            //height:2rem;
            background:#FAFAFA;
            display:flex;
            display:-webkit-flex;
            margin-bottom:0.38rem;
            .serve-item{
                width:640px;
                text-align:center;
                padding:30px 40px;
                position:relative;
                .icon-box{
                    width:32px;
                    height:50px;
                    margin:0 auto;
                    margin-bottom:28px;
                    img{
                        width:100%;
                        height:100%;
                        vertical-align:top;
                    }
                }
                .title{
                    font-size:0.16rem;
                    color:#222;
                    font-weight:bold;
                    margin-bottom:0.20rem;
                }
                .intro{
                    font-size:0.14rem;
                    color:#333;
                }
            }
            .serve-intro-left::after,.serve-intro-center::after{
                content:"";
                position:absolute;
                width:1px;
                height:96px;
                background:#e6e6e6;
                right:0;
                top:50%;
                transform:translateY(-50%);
            }
        }
        .success-cases{
            width:15.60rem;
            margin:0 auto;
            margin-bottom:56px;
            height:525px;
            display:flex;
            justify-content:space-between;
            .left-item{
                width:8.68rem;
                height:5.25rem;
                position:relative;
                top:50%;
                transform:translateY(-50%);
                img{
                    width:8.68rem;
                    height:4.25rem;
                    vertical-align:top;
                }
                .info{
                    height:1.02rem;
                    line-height:1.02rem;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
                    padding-left:40px;
                    transform: translateY(-2px);
                    .title{
                        font-size:0.28rem;
                        color:#000;
                        font-weight:bold;
                        margin-right:40px;
                        letter-spacing: 2px;
                        vertical-align:top;
                    }
                    .intro{
                        font-size:0.18rem;
                        color:#000;
                        letter-spacing: 2px;
                        vertical-align:top;
                    }
                }
            }
            .center-item{
                width:3.24rem;
                height:5.25rem;
                position:relative;
                top:50%;
                transform:translateY(-50%);
                img{
                    display:block;
                    width:100%;
                    height:calc(50% - 10px);
                }
                img:nth-of-type(1){
                    margin-bottom:20px;
                }
            }
            .right-item{
                width:3.24rem;
                height:5.25rem;
                position:relative;
                top:50%;
                transform:translateY(-50%);
                img{
                    width:100%;
                    height:100%;
                }
            }
        }
        .partners-wrap{
            height:90px;
            line-height:90px;
            width:15.60rem;
            margin:0 auto;
            margin-bottom:44px;
            display:flex;
            justify-content: space-between;
            .title{
                width:3rem;
                position:relative;
                img{
                    width:1.36rem;
                    height:0.66rem;
                    vertical-align:middle;
                }
            }
            .title::after{
                content:"";
                position:absolute;
                width:1px;
                height:0.9rem;
                background:#e6e6e6;
                right:0;
                top:50%;
                transform:translateY(-50%);
            }
            .item{
                width:12.60rem;
                display:flex;
                padding-left:1.18rem;
                justify-content: space-between;
                img{
                    width:1.36rem;
                    height:1.04rem;
                }
            }
        }
        .footer{
            height:56px;
            line-height:56px;
            background:#282828;
            .footer-content{
                width:1200px;
                height:56px;
                line-height:56px;
                margin:0 auto;
                display:flex;
                display:-webkit-flex;
                justify-content:space-between;
                .copyright{
                    height:56px;
                    line-height:56px;
                    span{
                        color:#999;
                        margin-right:80px;
                        height:56px;
                        line-height:56px;
                        font-size:0.14rem;
                        vertical-align:top;
                    }
                }
                .contact-box{
                    width:120px;
                    height:56px;
                    line-height:56px;
                    div{
                        display:inline-block;
                        position:relative;
                        margin-right:30px;
                    }
                    .code-img{
                        width:130px;
                        height:134px;
                        position:absolute;
                        left:-54px;
                        bottom:120px;
                    }
                    img{
                        width:30px;
                        height:30px;
                        vertical-align:top;
                        cursor:pointer;
                        transform: translateY(50%);
                    }
                }
            }
        }
        .back-to-top-wrap{
            width:45px;
            height:45px;
            position:fixed;
            bottom:60px;
            right:50px;
            z-index:99;
            cursor:pointer;
            background:url('../../assets/correcting-img/to-top.png') no-repeat;
            background-size:100% 100%;
        }
        .back-to-top-wrap:hover{
            opacity:0.8;
        }
    }
}
</style>

